<template>
    <pre v-highlight="formatCode" style="text-align:left;"><code :class="lang"></code></pre>
</template>

<script>
import beautify from 'js-beautify'
export default {
  name: 'h-highlight',
  props: {
    source: {
      type: String,
      default: ''
    },
    lang: {
      type: String,
      default: 'javascript'
    }
  },
  computed: {
    formatCode () {
      return beautify(this.source)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/highlight.vue